import { SUPPORTED_XLS_FORMATS } from './constants';

export const getIsExcel = (documentID: string) =>
  documentID && SUPPORTED_XLS_FORMATS.includes(documentID.split('.').pop().toLowerCase());
